import styled from 'styled-components'
import {
  BUTTON_SIZE,
  BUTTONS_GAP
} from '@website/common/components/BackToTopButton/consts'
import { floatingButtonStyles } from '@website/common/components/BackToTopButton/styled'

import { ICON_SIZE } from './consts'

export const Button = styled.button`
  ${floatingButtonStyles}
  position: absolute;
  top: 0;
  right: 0;
  transition: transform 0.2s;
  transform: ${({ isShifted }) =>
    isShifted ? `translateX(-${BUTTON_SIZE + BUTTONS_GAP}px)` : 'none'};

  & > svg {
    flex-shrink: 0;
    width: ${ICON_SIZE}px;
    height: ${ICON_SIZE}px;
    fill: ${({ theme }) => theme.palette.primaryDark};
  }
`
